import { AxiosResponse } from 'axios';

import { api } from 'tools/api-service';

import { GetFooterResponse } from './types/get-footer.type';

export const getFooter = async (
	locale = 'en'
): Promise<AxiosResponse<GetFooterResponse>> => {
	try {
		return await api.get(`/nav/${locale}/footer`);
	} catch (error) {
		// `getFooter` is used from `getStaticProps`, so it must not throw during
		// build/prerender when external APIs are blocked or misconfigured.
		console.error(
			`[getFooter] failed to load footer for locale=${locale}:`,
			error
		);

		// Keep a shape that matches `get-footer.schema.ts`.
		const emptyFooter: GetFooterResponse = {
			contactDetails: '',
			contactDetailsLink: {
				url: '',
				name: '',
			},
			copyright: '',
			footerLinks: [],
			socialLinks: [],
		};

		return {
			data: emptyFooter,
			status: 200,
			statusText: 'OK',
			headers: {},
			config: {},
			request: undefined,
		} as unknown as AxiosResponse<GetFooterResponse>;
	}
};
